import {
  API_ENDPOINT,
  useClientApiV2AuthSigninCreateMutation,
} from '../../resources/@types/accountSchema';

function useClientAuthSigninCreateMutation(
  options?: Parameters<typeof useClientApiV2AuthSigninCreateMutation>[0]['options'],
) {
  return useClientApiV2AuthSigninCreateMutation({
    url: API_ENDPOINT.CLIENT_V2_AUTH_SIGNIN,
    options,
  });
}

export default useClientAuthSigninCreateMutation;
